module.exports = __webpack_public_path__ + "img/xydj5.0d358888.png";